import './styles/ModalStyle.css';
import { useEffect, useState } from 'react';
import { useActions, useTypedSelector } from '../../hooks';
import {
  navigationPages,
  userInactivityPages,
} from '../../models/types/navigationPageType';
import { Button, Modal } from 'react-bootstrap';
import { languageMap } from '../../maps/languageMap';
import { useHistory } from 'react-router-dom';

const USER_DEFAULT_TIMEOUT = parseInt(
  process.env.REACT_APP_USER_TIMEOUT ?? '120'
);

const UserInactivityModal: React.FC = () => {
  let history = useHistory();
  const [modalSeconds, setModalSeconds] = useState(0);
  const language = useTypedSelector(({ session }) => {
    return session.language;
  });
  const showUserInactivityModal = useTypedSelector(({ session }) => {
    return session.showUserInactivityModal;
  });
  const userInactivitySeconds = useTypedSelector(({ session }) => {
    return session.userInactivitySeconds;
  });
  const { userInactivityShowModal, updateUserInactivitySeconds } = useActions();

  useEffect(() => {
    if (!showUserInactivityModal) {
      let interval: any = null;
      interval = setInterval(() => {
        if (userInactivitySeconds > USER_DEFAULT_TIMEOUT) {
          let currentPage = history.location.pathname.substring(1);
          if (!userInactivityPages.includes(currentPage)) {
            updateUserInactivitySeconds(0);
            userInactivityShowModal(true);
          }
        } else {
          setModalSeconds(0);
          updateUserInactivitySeconds(userInactivitySeconds + 1);
        }
      }, 1000);
      return () => clearInterval(interval);
    } else {
      let interval: any = null;
      interval = setInterval(() => {
        if (modalSeconds > USER_DEFAULT_TIMEOUT) {
          setModalSeconds(0);
          userInactivityShowModal(false);
          history.replace(`/${navigationPages.THANK_YOU}`);
        } else {
          setModalSeconds(modalSeconds + 1);
        }
      }, 1000);
      return () => clearInterval(interval);
    }
  }, [
    userInactivitySeconds,
    modalSeconds,
    history,
    showUserInactivityModal,
    userInactivityShowModal,
    updateUserInactivitySeconds,
  ]);
  const renderFooter = () => {
    return (
      <Modal.Footer>
        <Button
          onClick={() => {
            userInactivityShowModal(false);
            history.replace(`/${navigationPages.THANK_YOU}`);
          }}
          variant="secondary"
        >
          {languageMap.shell.user_timeout_cancel_button[language]}
        </Button>
        <Button
          onClick={() => {
            userInactivityShowModal(false);
          }}
          variant="success"
        >
          {languageMap.shell.user_timeout_confirm_button[language]}
        </Button>
      </Modal.Footer>
    );
  };
  return (
    <Modal
      show={showUserInactivityModal}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Header>
        <Modal.Title id="contained-modal-title-vcenter">
          {languageMap.shell.user_timeout_message[language]}
        </Modal.Title>
      </Modal.Header>
      {renderFooter()}
    </Modal>
  );
};

export { UserInactivityModal };
